import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 65;
  display: flex;
  align-items: flex-end;
`;

export const Backdrop = styled.button`
  position: absolute;
  inset: 0;
  border: none;
  background: transparent;
`;

export const Sheet = styled.div`
  position: relative;
  width: 100%;
  max-height: 80%;
  border-radius: 16px 16px 0 0;
  background: #fff;
  overflow: hidden;
  padding-bottom: 20px;
`;

export const DragHandle = styled.div`
  width: 40px;
  height: 4px;
  border-radius: 2px;
  margin: 8px auto 16px;
  background: #e0e0e0;
`;

export const ImageWrap = styled.div`
  position: relative;
`;

export const HeaderImage = styled.img`
  width: 100%;
  height: min(53vw, 360px);
  object-fit: cover;
  border-radius: 12px;
`;

export const DragHandleWrap = styled.div`
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
`;

export const Features = styled.div`
  padding: 20px 0;
`;

export const FeatureRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 20px 12px;
`;

export const Bullet = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6f7d95;
  margin-top: 6px;
`;

export const FeatureText = styled.div`
  font-size: 12px;
  color: #111827;
`;

export const ButtonWrap = styled.div`
  padding: 0 20px;
`;

export const PrimaryBtn = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(90deg, #144fcf 0%, #2a70f4 100%);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
`;

